import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { ListingAdHocTask1, TListingAdHocTask1Codec } from "../ListingAdHocTask";

export const ListingAdHocTaskEditable: TFormEditableCodec<TListingAdHocTask1Codec> = formEditable(ListingAdHocTask1);
export type TListingAdHocTaskEditableCodec = typeof ListingAdHocTaskEditable;
export type TListingAdHocTaskEditable = TTypeOfCodec<TListingAdHocTaskEditableCodec>;